// ═══════════════════════════════════════════════════════════════════
//  modules/erp/GlobalAuditPanel.js
//  GlobalAuditPanel
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useState } from "react";
import { Badge } from "../../composants/Badge";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { invActionLabel, invStatusColors } from "./audit";

export function GlobalAuditPanel({ token, onClose }) {
  const [rows, setRows] = useState(null);
  const [staff, setStaff] = useState("");
  const [player, setPlayer] = useState("");
  const load = async () => {
    const params = new URLSearchParams();
    if (staff) params.set("staff", staff);
    if (player) params.set("player", player);
    params.set("limit", "150");
    try {
      const res = await fetch(`${API_BASE}/api/inventory/audit?${params.toString()}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setRows(Array.isArray(data) ? data : []);
    } catch { setRows([]); }
  };
  // Volontaire : les filtres « staff » et « joueur » ne sont pas dans les
  // dépendances, ils sont appliqués par le bouton Filtrer.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <button onClick={onClose} style={{ background: "transparent", border: `1px solid ${THEME.border}`, color: THEME.textMuted, borderRadius: 6, padding: "6px 12px", cursor: "pointer", fontSize: 13 }}>← Retour</button>
        <h2 style={{ color: THEME.text, fontSize: 18, fontWeight: 700, margin: 0 }}>📜 Journal d'audit — inventaires</h2>
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <input value={staff} onChange={(e) => setStaff(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Filtrer par staff…"
          style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 6, padding: "8px 12px", color: THEME.text, fontSize: 13, outline: "none" }} />
        <input value={player} onChange={(e) => setPlayer(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Filtrer par joueur…"
          style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 6, padding: "8px 12px", color: THEME.text, fontSize: 13, outline: "none" }} />
        <button onClick={load} style={{ background: THEME.accentDim, border: `1px solid ${THEME.accent}`, color: THEME.accent, borderRadius: 6, padding: "8px 16px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>🔍 Filtrer</button>
      </div>
      {!rows && <div style={{ color: THEME.textMuted }}>Chargement…</div>}
      {rows && rows.length === 0 && <div style={{ color: THEME.textMuted, fontSize: 13, padding: 20, textAlign: "center" }}>Aucune action.</div>}
      {rows && rows.map((r) => {
        const sb = invStatusColors(r.status);
        return (
          <div key={r.id} style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 14px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                <span style={{ color: THEME.text, fontSize: 13, fontWeight: 600 }}>{r.player_name || r.uuid}</span>
                <Badge text={(r.container || "MAIN") === "ENDER" ? "Enderchest" : "Inventaire"} bg={THEME.surface} color={THEME.textMuted} />
                <span style={{ color: THEME.textMuted, fontSize: 12 }}>{invActionLabel(r.action)}{r.slot != null ? ` · slot ${r.slot}` : ""}{r.amount != null ? ` → ${r.amount}` : ""}</span>
              </div>
              <Badge text={r.status} bg={sb.bg} color={sb.col} />
            </div>
            <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 6 }}>
              par {r.requested_by || "?"} · {new Date(Number(r.created_at)).toLocaleString("fr")}
            </div>
          </div>
        );
      })}
    </div>
  );
}
